<template>
  <div>
  <ks-modal
      ref="crud_modal"
      position="centered"
      :showHeader="false"
      :backdropClose="false"
      :modalWidth="screenSizeId >= 3 ? '75' : '100'"
      :enableClose="true"
      :confirmRecordChanges="dataProvider"
      :preRender="preRender"
      :loading="loading"
  >
    <ks-modal-header
        :title="l_crudModalTitle"
    />
    <ks-modal-body>
      <ks-skeleton-list v-show="loading"/>
      <slot/>
    </ks-modal-body>
  </ks-modal>
  <ks-modal
      ref="campaignInactiveModal"
      position="centered"
      :backdropClose="false"
      :modalWidth="screenSizeId >= 3 ? '50' : '75'"
      :confirmRecordChanges="dataProvider"
      :preRender="preRender"
      :loading="loading"
      :darkShadow="true"
  >
    <ks-modal-header
        title="Campaign Inactive"
    />
    <ks-modal-body>
      Would you like to turn on this campaign so you can see this task?
    </ks-modal-body>
    <ks-modal-footer>
      <ks-button label="Yes" @onClick="activateCampaign"/>
      <ks-button label="No" @onClick="closeModals"/>
    </ks-modal-footer>
  </ks-modal>
  </div>
</template>

<script>

export default {
  name: 'auto_modal',
  props: {
    dataProvider: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    formName: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: false
    },
    preRender: {
      type: Boolean,
      default: true
    },
    extendPrepareFormData: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    screenSizeId() {
      return app.layout.screenSizeId;
    },
  },
  methods: {
    activateCampaign() {
      app.activateCampaign(this.itemCampaignId);
      this.closeModals();
    },
    closeModals() {
      this.$refs.campaignInactiveModal.hide();
      this.close();
    },
    close() {
      this.$refs.crud_modal.hide();
    },
    updateTitle(newItem = false) {
      if (newItem) {
        this.l_crudModalTitle = `Create ${this.name}`;
      } else {
        let data_provider = app.getDataprovider(this.dataProvider);
        let record = data_provider.getLocalRecord();
        this.l_crudModalTitle = `Update (${this.name} ${record.id}) ${this.itemName ? record[this.itemName] : ''}`;
      }
    },
    async open(item) {
      if (item?.campaign_id) {
        this.itemCampaignId = item.campaign_id;
        let isCampaignSelected = app.activeMultiCampaigns.find(campaign => campaign.id == item.campaign_id);
        if (!isCampaignSelected) {
          //alert("You are attempting to load something that belongs to a campaign that you do not have active. Please activate the campaign or reach out to your system admin.");
          this.$refs.campaignInactiveModal.show()
        }
      }

      this.$refs.crud_modal.show();
      this.loading = true;
      //setTimeout(async () => {
      try {
        let data_provider = app.getDataprovider(this.dataProvider);
        await data_provider.setLocalRecordToNewRecord();
        if (typeof item?.id == 'undefined' || item?.id == null) {
          //new record
          this.updateTitle(true);
          if (this.extendPrepareFormData) {
            await this.$slots.default[0].context.$refs[this.formName].prepareFormData(item);
          }
          this.loading = false;
        } else {
          //read the record
          this.l_crudModalTitle = `Update (${this.name} ${item?.id}) ${item[this.itemName] ? item[this.itemName] : ''}`;
          await data_provider.readRecord(item.campaign_id, item?.id);
          // if (this.extendPrepareFormData) {
          //   await this.$slots.default[0].context.$refs[this.formName].prepareFormData(item);
          // }
          // await this.$slots.default[0].context.$refs[this.formName].prepareEdit(item);
          if (typeof item[this.itemName] == 'undefined') {
            this.updateTitle();
          }
          this.loading = false;
        }
      } catch (err) {
        console.log(err);
      }
      //}, 100);
    },
  },
  data() {
    return {
      l_crudModalTitle: null,
      loading: false,
      itemCampaignId: null
    }
  }
}


</script>
